module.exports = __webpack_public_path__ + "0ca9c9e3b526b12d693a57cf3eb246ab.svg";